import React, { memo } from "react";

const TickIcon = () => {
    return (
        <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 5L4 8L11 1" stroke="#C4B2A9" strokeWidth="2" />
        </svg>
    );
};

export default memo(TickIcon);
